
<br>
<br>

<div class="pagination-controls">
    <!-- <button mat-button (click)="prevPage()" [disabled]="currentPage === 1">
      Previous
    </button> -->

    <button mat-button  (click)="prevPage()" [disabled]="currentPage === 1">
      <i class="fa fa-arrow-left"></i> 
    </button>
    <span>Page {{ currentPage }} of {{ totalPages() }}</span>
    <!-- <button mat-button (click)="nextPage()" [disabled]="currentPage === totalPages()">
      Next
    </button> -->
 

    <button mat-button   (click)="nextPage()" [disabled]="currentPage === totalPages()">
       <i class="fa fa-arrow-right"></i> 
    </button>
    <mat-form-field style="width:100px ;">
      <mat-label>Items per page:</mat-label>
      <mat-select [(value)]="pageSize" (selectionChange)="onPageSizeChange($event.value)">
        <mat-option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</mat-option>
      </mat-select>
    </mat-form-field>
    
  </div>
  
